module.exports = __webpack_public_path__ + "static/img/section7_content1_Bg2.f8a19ed3.png";